<nz-select
  #select
  [nzSize]="size"
  [(ngModel)]="value"
  [nzDropdownMatchSelectWidth]="false"
  [nzCustomTemplate]="custom"
  [nzPlaceHolder]="placeholderTpl"
  [nzShowSearch]="showSearch"
  [nzShowArrow]="showArrow"
  [nzDisabled]="disabled"
  (ngModelChange)="onValueChange($event)"
  (nzOpenChange)="open = !open"
  class="v4-filter-style"
  [class.ant-select-active]="value !== placeholderValue">
  <nz-option
    *ngFor="let item of listOfOption"
    [nzValue]="item.value"
    [nzLabel]="item.i18nKey ? (item.i18nKey | translate) : item.label"></nz-option>
  <ng-template #custom let-selected>
    <span *ngIf="selected.nzValue !== placeholderValue">{{ selected.nzLabel }}</span>
    <span class="select-default-placeholder test" *ngIf="selected.nzValue === placeholderValue">{{ placeholder }}</span>
  </ng-template>
</nz-select>

<ng-template #placeholderTpl>
  <span>{{ placeholder }}</span>
</ng-template>

<!--
<v4-custom-select>
  <nz-option
    *ngFor="let item of listOfOption"
    [nzValue]="item.value"
    [nzLabel]="item.i18nKey ? (item.i18nKey | translate) : item.label"></nz-option>
</v4-custom-select> -->
